export enum TextAlign {
	left = 'left',
	center = 'center',
	right = 'right'
}